import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs";
import { ApiExternalLinksConstants } from "../../constants/api-constants/api-external-links.constants";
let ApplicationExternalLinksService = class ApplicationExternalLinksService {
    http;
    constructor(http) {
        this.http = http;
    }
    getEditableSurveyLinks(params) {
        return this.http.post(ApiExternalLinksConstants.URL_SURVEY_LINKS, params).pipe(map(surveys => {
            return surveys;
        }));
    }
    getArcGisItemsObservable(params) {
        return this.http.get(ApiExternalLinksConstants.URL_ARCGIS_ITEMS, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ApplicationExternalLinksService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationExternalLinksService);
export { ApplicationExternalLinksService };
